<div class="min-h-screen flex w-full items-center justify-center p-8">
    <div class="flex flex-col w-full max-w-[400px] items-center">
        <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogo.svg')] bg-no-repeat bg-center"></div>
        <div class="pt-4 flex flex-row items-center">
            <div class="p-2">
                <je-fa-icon [name]="'circle-info'"></je-fa-icon>
            </div>
            <div class="p-2">
                {{ 'PAGES.UNSUPPORTED_BROWSER.TITLE' | translate }}
            </div>
        </div>
    </div>
</div>
